const emailNotificationOption = {
    STANDARD : 'STANDARD',

    CUSTOM : 'CUSTOM',

    NONE : 'NONE'

};

angular.module('gw-um-j2js')
    .constant('emailNotificationOption', emailNotificationOption);